import { render } from "./TemplateBookBookingConfirmation.vue?vue&type=template&id=448fdd78&scoped=true"
import script from "./TemplateBookBookingConfirmation.vue?vue&type=script&lang=js"
export * from "./TemplateBookBookingConfirmation.vue?vue&type=script&lang=js"

import "./TemplateBookBookingConfirmation.vue?vue&type=style&index=0&id=448fdd78&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-448fdd78"

export default script